import React, { useContext } from 'react';
import moment, { Moment } from 'moment-timezone';
import { Crew } from '../../Models/Crew';
import { observable, action } from 'mobx';
import { number, string } from 'prop-types';

import { CalendarNote } from '../../Models/CalendarNote';

const store: any = observable({
  isCalendarLoading: false,
  setIsCalendarLoading: action(
    (val: boolean) => (store.isCalendarLoading = val)
  ),
  isCalendarControlsDisabled: false,
  setCalendarControlsDisabled: action(
    (val: boolean) => (store.isCalendarControlsDisabled = val)
  ),
  refreshHook: 0,
  webhookAnimationInterval: -1,
  goRefresh: action(() => store.refreshHook++),
  get batchLength() {
    if (store.gridNumber) {
      return store.gridNumber - 1;
    }
    return 0;
  },
  today: null,
  firstLoad: true,
  currentShiftCardView: [],
  allUserShiftCardViews: [],
  setFirstLoad: action((val: any) => (store.firstLoad = val)),
  setToday: action((today: moment.Moment) => {
    let startOfWeek = moment().startOf('day');
    startOfWeek = startOfWeek.startOf('week');
    const offset = today.diff(startOfWeek, 'days') - 1;
    store.today = today;
    store.setBatchStartDay(today.clone().day(offset));
  }),

  currentWeek: null,
  currentMonth: null,
  selectedShiftDate: string,
  setSelectedShiftDate: action(
    (str: string) => (store.selectedShiftDate = str)
    //localStorage.setItem('selectedShiftDate', str)
  ),
  crews: [],
  setCrews: action((crews: Crew) => (store.crews = crews)),
  publishing: false,
  setPublishing: action((state: boolean) => (store.publishing = state)),
  processing: false,
  setProcessing: action((state: boolean) => (store.processing = state)),

  openSuccess: false,
  setOpenSuccess: action((state: boolean) => (store.openSuccess = state)),
  successMessage: 'Success',
  setSuccessMessage: action((state: string) => (store.successMessage = state)),
  resourceListItems: [],
  setResourceListItems: action(
    (items: any) => (store.resourceListItems = items)
  ),
  quoteDetails: [],
  setQuoteDetails: action((details: any) => (store.quoteDetails = details)),
  crewData: [],
  notes: [],
  setNotes: action((notes: CalendarNote[]) => (store.notes = notes)),
});

const context = React.createContext(store);

export const useCrewCalender = () => {
  return useContext(context);
};
